import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/page4': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 504C111 504 0 393 0 256S111 8 248 8C268.9 8 289.3 10.6 308.7 15.5L42.3 392H248V504zM248 360.4V146.8L98.6 360.4H248zM344 392V484.7C389.7 465.5 428.5 433 455.4 392H344zM401.4 253.8L380.2 262.2 401.4 270.5V253.8zM381.1 308.3C374.4 308.3 373.1 314.6 373.1 321.2V328.9H389.3V318.9C389.3 313 387 308.3 381.1 308.3zM496 256C496 293.3 487.8 328.7 473 360.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6H428.6V96H414.7V128.6H400.8V99H386.9V128.6H374.2V96H360.3V143.6zM428.5 328.9H402V317.9C402 302.5 396.4 292.7 381.1 292.7 365.7 292.7 360.4 303.3 360.4 318.6V343.9H428.6V328.9zM428.5 225.9L360.3 255.6V268L428.5 297.5V280.9L414.1 275.2V248.7L428.5 242.8V225.9zM423.7 157.4H388.1V184H402V171.8H413C421.6 187.6 414.3 207.1 394.4 207.1 371.9 207.1 366.1 181.8 378.9 169.4L367.3 158.8C351.1 176.3 355.1 222.7 394.4 222.7 428.4 222.7 439.1 186.8 423.7 157.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/page4.js
// module id = 1cWo
// module chunks = 144